$(document).ready(function() {
	
	var isTouch = false,
		hasMultiTouch = false;

	function showFormErrors(message, el) {
		console.log(message, el);
	}

	if ('ontouchstart' in window) {
		isTouch = true;
	}

	if (navigator.maxTouchPoints) {
		hasMultiTouch = true;
	}

	// Manage Size Validation
	var addToBagForm = $('.js-add-to-bag'),
		formSubmitButton = $('.c-product__add-to-bag');

	var currentSlideIndex = 0;

	$('.js-fs-button').on('click', function () {
		$('.js-gallery-fs').toggleClass('u-1/1@desktop')
		$('.js-gallery-fs').toggleClass('u-1/2@desktop')
		$('.js-content-fs').toggleClass('u-1/1@desktop')
		$('.js-content-fs').toggleClass('u-1/2@desktop')
	});

	var productImageGalleryThumbs = $('.js-gallery-thumbs');

	var productImageThumbs = $(productImageGalleryThumbs).flickity({
		cellSelector: '.js-gallery-thumbs__item',
		lazyLoad: true,
		resize: true,
		groupCells: true,
		cellAlign: 'left',
		adaptiveHeight: true,
		setGallerySize: false,
		selectedAttraction: 0.2,
		adaptiveHeight: true,
		friction: 1,
		pageDots: false,
		prevNextButtons: false,
		dragThreshold: 40
	});

	var productGallery = $('.js-gallery').flickity({
		cellSelector: '.js-gallery__item',
		resize: true,
		wrapAround: true,
		groupCells: true,
		cellAlign: 'left',
		adaptiveHeight: true,
		setGallerySize: false,
		selectedAttraction: 0.2,
		friction: 1,
		prevNextButtons: false,
		pageDots: false,
		draggable: true,
		dragThreshold: 40,
		lazyLoad: 1
	});

	$('.js-gallery-thumbs .flickity-slider').addClass('o-layout o-layout--tiny u-text-align-center');

	$('.js-gallery-fs .c-product__thumbnail').each(function (i, thumb) {
		$(thumb).on('click', function (e) {
			e.preventDefault();
			$(productGallery).flickity('select', i);
			$('.js-gallery-fs .c-product__thumbnail').removeClass('c-product__thumbnail--selected');
			$(this).addClass('c-product__thumbnail--selected');

		});
	});

	// var zoomLevel = 1;

	// $('.js-zoom-out-button').addClass('c-product__ui-button--disabled');

	// $('.js-zoom-out-button').on('click', function (ev) {
	// 	if (zoomLevel > 1) zoomLevel = 1;
	// 	$(zoomInstances)[currentSlideIndex].panzoom('zoom', zoomLevel, {
	// 		animate: true
	// 	}, true);

	// 	$(this).addClass('c-product__ui-button--disabled');
	// 	$('.js-zoom-in-button').removeClass('c-product__ui-button--disabled');
	// });

	// $('.js-zoom-in-button').on('click', function (ev) {
	// 	if (zoomLevel < 3) zoomLevel = 3;
	// 	$(zoomInstances)[currentSlideIndex].panzoom('zoom', zoomLevel, {
	// 		animate: true
	// 	});

	// 	$(this).addClass('c-product__ui-button--disabled');
	// 	$('.js-zoom-out-button').removeClass('c-product__ui-button--disabled');
	// });

	$('.js-product-gallery-next').on('click', function () {
		$(productGallery).flickity('next');
	});

	$('.js-product-gallery-previous').on('click', function () {
		$(productGallery).flickity('previous');
	});

	$('.c-product__thumbnail-button--next').on('click', function () {
		$(productImageThumbs).flickity('next');
	});

	$('.c-product__thumbnail-button--previous').on('click', function () {
		$(productImageThumbs).flickity('previous');
	});

	productGallery.on('change.flickity', function (event, index) {
		$('.js-gallery-fs .c-product__thumbnail').removeClass('c-product__thumbnail--selected');
		$('.js-gallery-fs .c-product__thumbnail').eq(index).addClass('c-product__thumbnail--selected');
	});

	function galleryNavigation() {
		if ($(window).width() > 740) {
			$('.js-gallery').on('mouseover', function () {
				$('.js-product-gallery-next').stop().fadeIn();
				$('.js-product-gallery-previous').stop().fadeIn();
			});

			$('.js-gallery').on('mouseleave', function () {
				$('.js-product-gallery-next').stop().fadeOut();
				$('.js-product-gallery-previous').stop().fadeOut();
			});
		} else {
			$('.js-gallery').off('mouseover');
			$('.js-gallery').off('mouseleave');
		}
	}

	if ($('.js-gallery').length) {

		galleryNavigation();

		$(window).resize(function () {
			galleryNavigation();
		});
	}

	$('.c-product__image').first().fadeIn().delay(450);

	// if (!isTouch) {	
	// 	$(zoomInstances).each(function (i, el) {

	// 		var neg = false;

	// 		$(this).find('img').dblclick(function (event) {

	// 			var cursor;

	// 			if (zoomLevel < 3 && zoomLevel === 1) neg = false;
	// 			if (zoomLevel === 3 && zoomLevel !== 1) neg = true;

	// 			if (neg) zoomLevel = 1;
	// 			else zoomLevel = 3;

	// 			if (neg) cursor = 'minus';
	// 			else cursor = 'plus';

	// 			$(el).panzoom('zoom', zoomLevel, {
	// 				animate: true
	// 			});

	// 			if (zoomLevel === 3) {
	// 				$('.js-zoom-out-button').removeClass('c-product__ui-button--disabled');
	// 				$('.js-zoom-in-button').addClass('c-product__ui-button--disabled');
	// 			}
				
	// 			if (zoomLevel === 1) {
	// 				$('.js-zoom-out-button').addClass('c-product__ui-button--disabled');
	// 				$('.js-zoom-in-button').removeClass('c-product__ui-button--disabled');
	// 			}

	// 			// $('.c-product__image > img').css({ cursor: 'url(/assets/img/search-' + cursor + '.png) 24 30, default !important' })

	// 		});
	// 	});
	// }

	// $(zoomInstances)[currentSlideIndex].on('touchstart', function (e) {
	// 	if (e.touches.length > 1) {
	// 		$(zoomInstances)[currentSlideIndex].panzoom('enablePan');
	// 	} else if (e.touches.length === 1) {
	// 		// $(zoomInstances)[currentSlideIndex].panzoom('disablePan');
	// 	}
	// });

	// $('.c-product__image > img').css({ cursor: 'url(/assets/img/search-plus.png) 24 30, default !important' })

	productGallery.on('change.flickity', function (event, index) {
		currentSlideIndex = index;
		// zoomLevel = 1;
		// $(zoomInstances)[index].panzoom("setMatrix", [1, 0, 0, 1, 0, 0], {
		// 	animate: true
		// });
		$('.c-product__image').eq(index).fadeIn();
	});

	var $imgs = $('.c-product__image');
	var flkty = productGallery.data('flickity');

	productGallery.on('scroll.flickity', function (event, progress) {
		flkty.slides.forEach(function (slide, i) {
			var img = $imgs[i];
			var x = (slide.target + flkty.x) * -1 / 3;
		});
	});

	$('.c-product__images img').imagesLoaded(function () {
		$('.c-product__thumbnails').fadeIn();
	});

	if (!isTouch && imageSizeOK) {
		$('.js-zoom-helper').fadeIn();
		$('.js-zoom-helper').delay(3000).fadeOut();
	}

	function galleryViewportSize() {

		$('.c-product__thumbnails').css({
			height: $('.js-gallery-thumbs .flickity-viewport').height()
		});
	}

	if ($('.c-product__thumbnails').length) {
		$(window).resize(galleryViewportSize);
		productImageGalleryThumbs.on('ready.flickity', galleryViewportSize);
	}

	/**
	 * Button Hover Effects
	 */

	 var btn = $('a.c-btn--fx:not(.c-btn--nofx), button.c-btn--fx:not(.c-btn--nofx)');

	 $(btn).append('<span class="c-btn-effect"></span>');

	 var animSpeed = 233;
	 var glowSize = 340;

	 $(btn).each(function(index, button) {
		
		 var parentOffset = $(button).offset();

		 window.onresize = function() { 
			 parentOffset = $(button).offset();
		 };
		 
		 $(button).on('mousemove', function (e) {
			var relX = e.pageX - parentOffset.left;
			var relY = e.pageY - parentOffset.top;

			var fx = $(button).find('.c-btn-effect');
	
				$(fx).css({
					left: relX,
					top: relY,
					height: glowSize,
					width: glowSize,
					opacity: 1
				}, animSpeed);
		 });

		 $(button).on('mouseout', function (e) {
			 $(button).find('.c-btn-effect').css({ height: glowSize / 2, width: glowSize / 2, opacity: 0 }, animSpeed);
		 });
	 });


	 $('.c-btn-effect').animate({
	 	height: 0,
	 	width: 0
	 }, 100);
});
